__turbopack_context__.v({
  "anchorLink": "filter-module-scss-module__R24I7q__anchorLink",
  "anchorLinkDisabled": "filter-module-scss-module__R24I7q__anchorLinkDisabled",
  "container": "filter-module-scss-module__R24I7q__container",
  "containerAnchor": "filter-module-scss-module__R24I7q__containerAnchor",
  "containerDropdown": "filter-module-scss-module__R24I7q__containerDropdown",
  "containerSearch": "filter-module-scss-module__R24I7q__containerSearch",
  "dropdownAnchor": "filter-module-scss-module__R24I7q__dropdownAnchor",
  "dropdownButton": "filter-module-scss-module__R24I7q__dropdownButton",
  "dropdownTitle": "filter-module-scss-module__R24I7q__dropdownTitle",
  "isSticky": "filter-module-scss-module__R24I7q__isSticky",
  "search": "filter-module-scss-module__R24I7q__search",
});
